import React from "react";

import StyledUserCard from "./styles";
import { Typography, Divider, Chip, Button } from "@mui/material";
import UserPicture from "../user-picture";
import SchoolIcon from "@mui/icons-material/School";

const UserCard = (props) => {
  const { profilePicture, name, surname, university, onUserClick, buttonText } =
    props;

  const onUserClickHandler = () => {
    if (onUserClick) {
      onUserClick(props);
    }
  };

  return (
    <StyledUserCard onClick={onUserClickHandler}>
      <div className="user-card-cont">
        <div className="user-card-header">
          <UserPicture
            image={profilePicture}
            name={name}
            surname={surname}
            size={70}
          />
          <div className="user-card-title">
            {name && surname && (
              <Typography variant="subtitle1">
                {name} {surname}
              </Typography>
            )}

            {university && (
              <div className="user-card-uni">
                <SchoolIcon sx={{ width: 20, height: 20 }} />
                <Typography variant="caption">{university}</Typography>
              </div>
            )}
          </div>
        </div>

        {buttonText && (
          <div>
            <Button>{buttonText}</Button>
          </div>
        )}
      </div>
    </StyledUserCard>
  );
};

export default UserCard;
